import PageHeaderTitle from '../atoms/PageHeaderTitle';
const PageHeader = ({
  children,
  backLink,
  RightSideComponent,
  testid,
  ...props
}) => {
  return (
    <div className='mb-4 grid items-center sm:grid-cols-2'>
      {backLink && (
        <div className='col-span-2 my-4 hidden items-center sm:flex'>
          {backLink}
        </div>
      )}
      <div className=' text-center sm:text-left'>
        <PageHeaderTitle testid={testid}>{children}</PageHeaderTitle>
      </div>
      <div className=' text-center sm:text-right'>
        {RightSideComponent && <RightSideComponent {...props} />}
      </div>
    </div>
  );
};

export default PageHeader;
